<template>
  <div class="report-history">
    <v-divider v-if="userTeam=='IT'" class="primary"></v-divider>
    <v-container v-if="userTeam=='IT'">
      <v-row justify="center">
        <v-card>
          <v-card-title>
              <h4 class="headline">
                  Completed Assignments
              </h4>
          </v-card-title>
          <v-card-title>
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
          >
          </v-data-table>
        </v-card>
      </v-row>
    </v-container>
    <v-divider class="primary"></v-divider>
    <SearchReport />
  </div>
</template>

<script>
/* eslint-disable no-console */
import SearchReport from '@/components/algolia/SearchReport.vue'
import {db, auth} from '@/fb'
export default {
  name: 'ReportHistory',
  data(){
      return {
        search:'',
        headers: [
            {
                text: 'Ticket Number',
                align: 'left',
                filterable: true,
                value: 'ticket_number',
            },
            { text: 'Price', value: 'price' },
            { text: 'Concierge', value: 'concierge' },
            { text: 'Researcher', value: 'researcher'},
            { text: 'Hand in Month', value: 'hand_in_month'},
            { text: 'Approved', value: 'approved'},
        ],
        items:[],
        userTeam:null,
      }
  },
  components:{SearchReport},
  
  methods:{

  },
  created(){
    let currentUser = auth.currentUser.uid
    let user_ref = db.collection('users').doc(currentUser)
    user_ref.get().then(doc=>{
      if(doc.data().team != null){
        this.userTeam = doc.data().team
      }
    })
    .catch(err=>{
      console.log(err)
    })
    let ref = db.collection('ticket_completed').orderBy("ticket_number", "desc")
    ref.get().then(snap=>{
      snap.forEach(doc => {
        this.items.push({
          'ticket_number':doc.data().ticket_number,
          'price':doc.data().price,
          'concierge':doc.data().concierge_in_charge,
          'researcher': doc.data().submitted_by,
          'hand_in_month':doc.data().hand_in_month,
          'approved':doc.data().pay_for_ticket,
        })
      });
    })
  }
}
</script>